import React from "react";
import { FrontendAdminLogs } from "node-library/dist/portal";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Typography,
} from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { formatCustomDate } from "node-library/dist/helpers/date_helper";

interface LogsPageContentProps {
	logs: FrontendAdminLogs[];
}

export default function LogsPageContent({ logs }: LogsPageContentProps) {
	const { t: translation } = useTranslation();

	if (!logs || logs.length === 0) {
		return (
			<Typography variant="body1" align="center" sx={{ mt: 4 }}>
				{translation("NoLogs")}
			</Typography>
		);
	}

	return (
		<TableContainer component={Paper}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>
							<strong>Timestamp</strong>
						</TableCell>
						<TableCell>
							<strong>User</strong>
						</TableCell>
						<TableCell>
							<strong>Full Name</strong>
						</TableCell>
						<TableCell>
							<strong>Action</strong>
						</TableCell>
						<TableCell>
							<strong>Table</strong>
						</TableCell>
						<TableCell>
							<strong>Record ID</strong>
						</TableCell>
						<TableCell>
							<strong>Source</strong>
						</TableCell>
						<TableCell>
							<strong>Details</strong>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{logs.map((log) => (
						<TableRow key={log.logId || `${log.userName}-${log.inserted}`}>
							<TableCell>
								{log.inserted ? formatCustomDate(new Date(log.inserted)) : "-"}
							</TableCell>
							<TableCell>{log.userName}</TableCell>
							<TableCell>{log.userFullName}</TableCell>
							<TableCell>{log.action}</TableCell>
							<TableCell>{log.tableName}</TableCell>
							<TableCell>{log.tableRecordId}</TableCell>
							<TableCell>{log.source}</TableCell>
							<TableCell>{log.actionDetails || "-"}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
